import React, { Fragment, useEffect, useState } from "react";
import { graphql, Script, useStaticQuery } from "gatsby";
import ImageView from "../components/ImageView";
import VideoPopup from "../components/VideoPopup";
import { animation } from "../utils";
import Footer from "./Footer";
import Header from "./Header";
import ScrollTop from "./ScrollTop";
import PreLoader from "./PreLoader";
import LandingHeader from "../components/tailwind/LandingHeader";

const Layout = ({ children, header, footer, location }) => {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    animation();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoader(false), 2000);
    return () => clearTimeout(timer);
  });
  const { sanitySitesettings, allSanityBlog, allSanityLandingPage } =
    useStaticQuery(
      graphql`
        query {
          allSanityLandingPage {
            nodes {
              slug {
                current
              }
            }
          }
          sanitySitesettings {
            topBanner {
              enable
              welcome
              time
              social {
                icon
                url
              }
            }
            header {
              logo {
                alt
                asset {
                  gatsbyImageData(
                    formats: WEBP
                    fit: FILLMAX
                    placeholder: BLURRED
                  )
                }
              }
              logo2 {
                alt
                asset {
                  gatsbyImageData(
                    fit: FILLMAX
                    formats: WEBP
                    placeholder: BLURRED
                  )
                }
              }
              button {
                title
                linkType
                link
                btnType
              }
              menu {
                parent {
                  label
                  link
                  type
                }
                childMenu {
                  type
                  link
                  label
                }
              }
            }
            footer {
              logo {
                alt
                asset {
                  gatsbyImageData(fit: FILLMAX, placeholder: DOMINANT_COLOR)
                }
              }
              about
              email
              location
              _rawCc
              menu {
                label
                link
                type
              }
              serviceAreas {
                title
                links {
                  label
                  link
                  type
                }
              }
              newsletter {
                enable
                heading
                button {
                  btnType
                  link
                  linkType
                  title
                }
              }
              social {
                icon
                url
              }
            }
          }
          allSanityBlog(limit: 2, sort: { _createdAt: DESC }) {
            edges {
              node {
                title
                slug {
                  current
                }
                thumbnail {
                  alt
                  asset {
                    url
                  }
                }
                publishedAt
              }
            }
          }
        }
      `
    );

  // Check if current path matches any landing page slug
  const isLandingPage = allSanityLandingPage.nodes.some((node) => {
    // Need to check for both /slug-name and /slug-name/ formats
    const slugPath = `/${node.slug.current}`;
    return (
      location.pathname === slugPath || location.pathname === `${slugPath}/`
    );
  });

  return (
    <Fragment>
      {/* {loader && <PreLoader />} */}
      {/* <VideoPopup /> */}
      <ImageView />
      {!isLandingPage ? (
        <Header
          header={header}
          data={sanitySitesettings.header}
          topBanner={sanitySitesettings.topBanner}
        />
      ) : (
        <LandingHeader data={sanitySitesettings.header} />
      )}

      {children}
      {!isLandingPage && (
        <Footer
          footer={footer}
          data={sanitySitesettings?.footer}
          news={allSanityBlog}
        />
      )}
      <ScrollTop />
      <Script
        id="6senseWebTag"
        src="https://j.6sc.co/j/e8466ddb-252c-4efb-997d-7f2a08b477e6.js"
      ></Script>
    </Fragment>
  );
};
export default Layout;
